import React from "react";

export const STEPS = [
  { key: "review", label: "Review" },
  { key: "verify", label: "Verify" },
  { key: "execute", label: "Execute" },
  { key: "result", label: "Result" },
];

export function Stepper({ current, onSelect }) {
  const idx = STEPS.findIndex((s) => s.key === current);
  return (
    <ol className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid="ldc01-stepper">
      {STEPS.map((s, i) => {
        const active = i === idx;
        return (
          <li key={s.key}>
            <button type="button" onClick={() => onSelect(s.key)} data-testid={`ldc01-step-${s.key}`}
              aria-current={active ? "step" : undefined}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-sm border text-left transition-colors ${
                active ? "border-[var(--accent)] bg-[var(--accent)]/10 text-white"
                  : "border-[var(--border)] text-zinc-400 hover:text-white hover:bg-[var(--bg-2)]"}`}>
              <span className={`w-6 h-6 shrink-0 rounded-full flex items-center justify-center text-[11px] font-mono font-bold ${
                active ? "bg-[var(--accent)] text-white" : "bg-[var(--bg-2)] text-zinc-500"}`}>
                {i + 1}
              </span>
              <span className="text-xs uppercase tracking-widest font-semibold">{s.label}</span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
